import {
  BanIcon,
  BookOpenIcon,
  SwitchHorizontalIcon,
  TemplateIcon,
  ThumbUpIcon,
  UserIcon,
} from "@heroicons/react/solid";

export enum AuditActions {
  UPDATE = "UPDATED",
  CREATE = "CREATED",
  CHANGED = "CHANGED",
}

export const EventTypes: { [key: string]: { icon: JSX.Element } } = {
  UPDATE: {
    icon: <SwitchHorizontalIcon className="h-5 w-5 text-blue-500" />,
  },
  SUBMITTED: {
    icon: <UserIcon className="h-5 w-5 text-neutralColor-normal" />,
  },
  CREATE: {
    icon: <TemplateIcon className="h-5 w-5 text-neutralColor-normal" />,
  },
  UNDER_REVIEW: {
    icon: <BookOpenIcon className="h-5 w-5 text-secondaryColor-normal" />,
  },
  DENY: { icon: <BanIcon className="h-5 w-5 text-tertiaryColor-normal" /> },
  HOLD: { icon: <SwitchHorizontalIcon className="h-5 w-5 text-cyan" /> },
  APPROVED: {
    icon: <ThumbUpIcon className="h-5 w-5" />,
  },
};
